module.exports = __webpack_public_path__ + "static/media/greenTick.9cd694d5.svg";